var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C4.45312 0.5 0 4.99219 0 10.5C0 16.0469 4.45312 20.5 10 20.5C15.5078 20.5 20 16.0469 20 10.5C20 4.99219 15.5078 0.5 10 0.5ZM14.4922 13.2422C14.9219 13.6719 14.9219 14.3359 14.4922 14.7656C14.0625 15.1953 13.3984 15.1953 12.9688 14.7656L10 11.7969L7.03125 14.7656C6.60156 15.1953 5.9375 15.1953 5.50781 14.7656C5.07812 14.3359 5.07812 13.6719 5.50781 13.2422L8.47656 10.2734L5.50781 7.30469C5.07812 6.875 5.07812 6.21094 5.50781 5.78125C5.9375 5.35156 6.60156 5.35156 7.03125 5.78125L10 8.75L12.9688 5.78125C13.3984 5.35156 14.0625 5.35156 14.4922 5.78125C14.9219 6.21094 14.9219 6.875 14.4922 7.30469L11.5234 10.2734L14.4922 13.2422Z",
    fill: "#cc3b3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.9130162ff99c1908b612a7e809334e31.svg";
export { ForwardRef as ReactComponent };